import React from "react";
import Layout from "../Layout";
import Heading from "../Components/Heading";
import WorkSwiper from "../Components/WorkSwiper";

function Work() {
    return (
        <Layout>
            <div className="mx-4" data-aos="fade-down">
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-3">
                    <div className="md:col-span-2">
                        <div className="">
                            <Heading heading="Some Things I’ve Built" />
                        </div>
                    </div>
                </div>
                <WorkSwiper />
            </div>
        </Layout>
    );
}

export default Work;
